<template>
    <div v-if="loaded">
        <rkm-data-table
            :fields="fields"
            :repository="repositories.gerenciamento"
            :request-params="camelObjectKeysToSnakeRecursive(filters)"
            :tbody-tr-class="rowClass"
            ref="DataTable"
            sort-by="data"
        >
            <template v-slot:filters>
                <rkm-form
                    ref="Form"
                    class="mb-2"
                >
                    <rkm-area
                        no-margin-top
                        title="Filtros"
                        type="fieldset"
                    >
                        <template slot="trailing">
                            <rkm-button
                                @click="visible = !visible"
                                color="primary"
                                small
                            >
                                <rkm-icon :icon="visible ? 'angle-double-up' : 'angle-double-down'" />
                            </rkm-button>
                        </template>

                        <rkm-collapse :visible="visible">
                            <rkm-row>
                                <rkm-col>
                                    <rkm-form-input-autocomplete
                                        :repository="repositories.gerenciamento.usuarioSolicitante"
                                        :requestQueryStringParams="{
                                            periodo: model.periodo.date,
                                        }"
                                        :searchFields="fieldsAutocomplete.usuarioSolicitante"
                                        :text-field="u => `${u.nomeUsuarioSolicitante}`"
                                        @select="usuarioChange()"
                                        label="Usuario solicitante"
                                        placeholder="Digite o nome do usuário solicitante"
                                        uppercase
                                        v-model="model.usuarioSolicitanteId"
                                        value="id"
                                    />
                                </rkm-col>

                                <rkm-col>
                                    <rkm-form-multiselect
                                        :options="form.servicos || []"
                                        @update:dropdownClosed="servicoChange()"
                                        label="Serviço(s)"
                                        optionNameKey="nomeServico"
                                        optionTextSelecteds="servico selecionado"
                                        v-model="model.servicosId"
                                        value-field="id"
                                    />
                                </rkm-col>
                            </rkm-row>

                            <rkm-row>
                                <rkm-col>
                                    <rkm-form-multiselect
                                        :options="form.unidades || []"
                                        :select-limit="null"
                                        @update:dropdownClosed="unidadeChange()"
                                        label="Unidade(s) solicitante(s)"
                                        option-name-key="nomeUnidadeSolicitante"
                                        option-text-selecteds="unidade selecionado"
                                        v-model="model.unidadesSolicitantesId"
                                        value-field="id"
                                    />
                                </rkm-col>

                                <rkm-col>
                                    <rkm-form-multiselect
                                        :options="form.infraestruturas || []"
                                        :select-limit="null"
                                        @update:dropdownClosed="infraestruturaChange()"
                                        label="Local(is) de atendimento"
                                        option-name-key="nomeInfraestruturaSolicitante"
                                        option-text-selecteds="local selecionado"
                                        v-model="model.infraestruturasSolicitantesId"
                                        value-field="id"
                                    />
                                </rkm-col>
                            </rkm-row>

                            <rkm-row>
                                <rkm-col>
                                    <rkm-form-multiselect
                                        :options="form.grupos || []"
                                        @update:dropdownClosed="grupoChange()"
                                        label="Grupo(s)"
                                        option-name-key="nomeGrupo"
                                        option-text-selecteds="grupo selecionado"
                                        v-model="model.gruposId"
                                        value-field="id"
                                    />
                                </rkm-col>

                                <rkm-col>
                                    <rkm-form-multiselect
                                        :options="form.subgrupos || []"
                                        @update:dropdownClosed="subgrupoChange()"
                                        label="Subgrupo(s)"
                                        option-name-key="nomeSubgrupo"
                                        option-text-selecteds="subgrupo selecionado"
                                        v-model="model.subgruposId"
                                        value-field="id"
                                    />
                                </rkm-col>
                            </rkm-row>

                            <rkm-row>
                                <rkm-col>
                                    <rkm-form-multiselect
                                        :options="form.status || []"
                                        @update:dropdownClosed="statusChange()"
                                        label="Status"
                                        option-name-key="nome"
                                        option-text-selecteds="status selecionado"
                                        v-model="model.statusId"
                                        value-field="id"
                                    />
                                </rkm-col>

                                <rkm-col>
                                    <rkm-form-multiselect
                                        :options="form.prioridades || []"
                                        label="Prioridade(s)"
                                        option-name-key="nomePrioridade"
                                        option-text-selecteds="prioridade selecionado"
                                        v-model="model.prioridadesId"
                                        value-field="id"
                                    />
                                </rkm-col>
                            </rkm-row>
                        </rkm-collapse>

                    </rkm-area>

                    <rkm-area
                        no-margin-top
                        title="Período"
                        type="fieldset"
                    >
                        <rkm-row>
                            <rkm-col>
                                <rkm-form-date-picker
                                    :end-validations="validations.periodo.date.end"
                                    :max-date="maxDate"
                                    :min-date="minDate"
                                    :range-inline="false"
                                    :start-validations="validations.periodo.date.start"
                                    end-label="Até"
                                    range
                                    start-label="Período de"
                                    v-model="model.periodo.date"
                                />
                            </rkm-col>

                            <rkm-col cols="auto">
                                <rkm-button
                                    :label="false"
                                    @click="$refs.Form.validate($refs.DataTable.search)"
                                    color="primary"
                                >
                                    Buscar
                                </rkm-button>

                                <rkm-button
                                    :label="false"
                                    @click="resetFilters"
                                    color="secondary"
                                >
                                    Limpar
                                </rkm-button>
                            </rkm-col>
                        </rkm-row>
                    </rkm-area>

                    <modalCancelamento
                        @refresh="$refs.DataTable.refresh()"
                        ref="modalCancelamento"
                    />

                    <modalMensagens
                        :form="form"
                        @refresh="$refs.DataTable.refresh()"
                        ref="modalMensagens"
                    />

                </rkm-form>
            </template>

            <template v-slot:cell(actions)="{item}">
                <rkm-button
                    @click="handleOpen(item)"
                    color="primary"
                    small
                    title="Atender"
                >
                    <rkm-icon icon="hand-holding-medical" />
                </rkm-button>

                <rkm-button
                    :disabled="item.statusId === enums.statusTipo.EM_ABERTO"
                    @click="handleMessage(item)"
                    color="warning"
                    small
                    title="Mensagem"
                >
                    <rkm-icon icon="comment" />
                </rkm-button>

                <rkm-button
                    :disabled="!!item.pendenteFinalizacao || item.statusId === enums.statusTipo.CANCELADO || item.statusId === enums.statusTipo.FINALIZADO"
                    @click="handleFinalize(item)"
                    color="success"
                    small
                    title="Finalizar"
                >
                    <rkm-icon icon="check-circle" />
                </rkm-button>

                <rkm-button
                    :disabled="!item.allowCancel || item.statusId === enums.statusTipo.CANCELADO || item.statusId === enums.statusTipo.FINALIZADO"
                    @click="handleCancel(item)"
                    color="danger"
                    small
                    title="Cancelar"
                >
                    <rkm-icon icon="ban" />
                </rkm-button>
            </template>

        </rkm-data-table>
    </div>
</template>

<script>
// Vuex.
import { mapActions } from 'vuex'

// Components.
import modalCancelamento from './components/cancelamento/Modal'
import modalMensagens from './components/mensagem/Modal'

// Mixins.
import { error, formats, repository, stringCase, object, file } from '@/mixins'

// Enums.
import statusTipo from '@/enums/manutencao/statusTipo'

// Others.
import moment from 'moment'

export default {
    components: {
        modalCancelamento,
        modalMensagens,
    },
    computed: {
        fields() {
            return [
                {key: 'data', name: 'solicitacao.createdAt', label: 'Data', sortable: true},
                {key: 'prioridade', name: 'prioridade.nomePrioridade', label: 'Prioridade', sortable: true},
                {key: 'codigo', name: 'solicitacao.codigo', label: 'Código', sortable: true},
                {key: 'grupo', name: 'grupo.nomeGrupo', label: 'Grupo', sortable: true},
                {key: 'subgrupo', name: 'subgrupo.nomeSubgrupo', label: 'Subgrupo', sortable: true},
                {key: 'servico', name: 'servico.nomeServico', label: 'Serviço', sortable: true},
                {key: 'assunto', name: 'solicitacao.assunto', label: 'Assunto', sortable: true},
                {key: 'dataAgendamento', name: 'solicitacao.dataAgendamento', label: 'Agendamento', sortable: true},
                {key: 'usuarioSolicitante', name: 'usuarioSolicitante.nomeUsuarioSolicitante', label: 'Usuário solicitante', sortable: true},
                {class: 'col-min', key: 'actions', label: 'Ações', name: 'actions'},
            ]
        },
        fieldsAutocomplete() {
            return {
                usuarioSolicitante: [
                    { key: 'cidadao.nome', searchable: true },
                ],
            }
        },
        filters() {

            return this.camelObjectKeysToSnakeRecursive({
                periodo: {
                    date: {
                        start: this.model.periodo.date.start,
                        end: this.model.periodo.date.end,
                    },
                },
                usuarioSolicitanteId: this.model.usuarioSolicitanteId,
                servicosId: this.model.servicosId,
                unidadesSolicitantesId: this.model.unidadesSolicitantesId,
                infraestruturasSolicitantesId: this.model.infraestruturasSolicitantesId,
                gruposId: this.model.gruposId,
                subgruposId: this.model.subgruposId,
                statusId: this.model.statusId,
                prioridadesId: this.model.prioridadesId,
            })
        },
        validations() {
            return {
                periodo: {
                    date: {
                        start: { required: true },
                        end: { required: true },
                    }
                }
            }
        },
        minDate() {

            const end = this.model.periodo.date.end
            const dataAtual = moment(this.additionals.dataAtual, 'DD/MM/YYYY')

            if (end != null) {

                return moment(end).subtract(3, 'months').format('DD/MM/YYYY')
            }

            if (this.model.periodo.date.start == null) {

                return null
            }

            return dataAtual.subtract(3, 'months').format('DD/MM/YYYY')
        },
        maxDate() {

            const start = this.model.periodo.date.start
            const dataAtual = moment(this.additionals.dataAtual, 'DD/MM/YYYY')

            if (start != null) {

                const end = moment(start).add(3, 'months')

                if (end.isBefore(dataAtual)) {

                    return end.format('DD/MM/YYYY')
                }
            }

            return dataAtual.format('DD/MM/YYYY')
        },
        statusIsFinalizado() {

            return this.form.pedenteFinalizacao || this.form.statusTipoId === this.enums.statusTipo.CANCELADO;
        }
    },
    created() {
        this.repositories = {
            gerenciamento: this.getConectaSusRepository('manutencao.gerenciamento'),
        }
        this.load();
    },
    data: () => ({
        model: null,
        form: null,
        additionals: null,
        loaded: false,
        visible: false,
        others: { moment },
        enums: { statusTipo },
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.setLoading();

            this.repositories.gerenciamento.list()
                .then(({ data }) => {
                    this.unsetLoading()

                    this.model = data.model
                    this.form = data.form
                    this.additionals = data.additionals

                    const dataAtual = moment(this.additionals.dataAtual, 'DD/MM/YYYY').format('YYYY-MM-DD');

                    this.$set(this.model.periodo.date, 'start', dataAtual);
                    this.$set(this.model.periodo.date, 'end', dataAtual);

                    this.loaded = true;

                    this.addPeriodoWatch();
                })
                .catch(() => {
                    this.unsetLoading();
                });
        },
        addPeriodoWatch() {

            this.$watch('model.periodo.date', {
                    deep: true,
                    handler() {

                        this.model.usuarioSolicitanteId = null;
                        this.model.servicosId = [];
                        this.model.unidadesSolicitantesId = [];
                        this.model.infraestruturasSolicitantesId = [];
                        this.model.gruposId = [];
                        this.model.subgruposId = [];
                        this.model.statusId = [];
                        this.model.prioridadesId = [];

                        this.form.servicos = [];
                        this.form.unidadesSolicitantes = [];
                        this.form.infraestruturasSolicitantes = [];
                        this.form.grupos = [];
                        this.form.subgrupos = [];
                        this.form.status = [];
                        this.form.prioridades = [];

                        const filter = this.getFilter();

                        if (filter) {

                            this.setLoading()

                            this.repositories.gerenciamento.list(filter)
                                .then(({ data }) => {

                                    this.form = this.clone(data.form);
                                })
                                .catch(this.handleError)
                                .finally(() => {
                                    this.usuarioChange();
                                    this.unsetLoading();
                                });
                        }
                    }
                });
        },
        usuarioChange() {

            this.model.servicosId = [];
            this.model.unidadesSolicitantesId = [];
            this.model.infraestruturasSolicitantesId = [];
            this.model.gruposId = [];
            this.model.subgruposId = [];
            this.model.statusId = [];
            this.model.prioridadesId = [];

            this.form.servicos = [];
            this.form.unidadesSolicitantes = [];
            this.form.infraestruturasSolicitantes = [];
            this.form.grupos = [];
            this.form.subgrupos = [];
            this.form.status = [];
            this.form.prioridades = [];

            const filter = this.getFilter();

            if (filter) {

                this.setLoading()

                this.repositories.gerenciamento.list(filter)
                    .then(({ data }) => {

                        this.form = this.clone(data.form);
                    })
                    .catch(this.handleError)
                    .finally(() => {
                        this.servicoChange();
                        this.unsetLoading();
                    });
            }

        },
        servicoChange() {

            this.model.unidadesSolicitantesId = [];
            this.model.infraestruturasSolicitantesId = [];
            this.model.gruposId = [];
            this.model.subgruposId = [];
            this.model.statusId = [];
            this.model.prioridadesId = [];

            this.form.unidadesSolicitantes = [];
            this.form.infraestruturasSolicitantes = [];
            this.form.grupos = [];
            this.form.subgrupos = [];
            this.form.status = [];
            this.form.prioridades = [];

            const filter = this.getFilter();

            if (filter) {

                this.setLoading()

                this.repositories.gerenciamento.list(filter)
                    .then(({ data }) => {

                        this.form.unidadesSolicitantes = this.clone(data.form.unidadesSolicitantes);
                        this.form.infraestruturasSolicitantes = this.clone(data.form.infraestruturasSolicitantes);
                        this.form.grupos = this.clone(data.form.grupos);
                        this.form.subgrupos = this.clone(data.form.subgrupos);
                        this.form.status = this.clone(data.form.status);
                        this.form.prioridades = this.clone(data.form.prioridades);
                    })
                    .catch(this.handleError)
                    .finally(() => {
                        this.unidadeChange();
                        this.unsetLoading();
                    });
            }

        },
        unidadeChange() {

            this.model.infraestruturasSolicitantesId = [];
            this.model.gruposId = [];
            this.model.subgruposId = [];
            this.model.statusId = [];
            this.model.prioridadesId = [];

            this.form.infraestruturasSolicitantes = [];
            this.form.grupos = [];
            this.form.subgrupos = [];
            this.form.status = [];
            this.form.prioridades = [];

            const filter = this.getFilter();

            if (filter) {

                this.setLoading()

                this.repositories.gerenciamento.list(filter)
                    .then(({ data }) => {

                        this.form.infraestruturasSolicitantes = this.clone(data.form.infraestruturasSolicitantes);
                        this.form.grupos = this.clone(data.form.grupos);
                        this.form.subgrupos = this.clone(data.form.subgrupos);
                        this.form.status = this.clone(data.form.status);
                        this.form.prioridades = this.clone(data.form.prioridades);
                    })
                    .catch(this.handleError)
                    .finally(() => {
                        this.infraestruturaChange();
                        this.unsetLoading();
                    });
            }

        },
        infraestruturaChange() {

            this.model.gruposId = [];
            this.model.subgruposId = [];
            this.model.statusId = [];
            this.model.prioridadesId = [];

            this.form.grupos = [];
            this.form.subgrupos = [];
            this.form.status = [];
            this.form.prioridades = [];

            const filter = this.getFilter();

            if (filter) {

                this.setLoading()

                this.repositories.gerenciamento.list(filter)
                    .then(({ data }) => {

                        this.form.grupos = this.clone(data.form.grupos);
                        this.subgrupos = this.clone(data.form.subgrupos);
                        this.status = this.clone(data.form.status);
                        this.prioridades = this.clone(data.form.prioridades);
                    })
                    .catch(this.handleError)
                    .finally(() => {
                        this.grupoChange();
                        this.unsetLoading();
                    });
            }

        },
        grupoChange() {

            this.model.subgruposId = [];
            this.model.statusId = [];
            this.model.prioridadesId = [];

            this.form.subgrupos = [];
            this.form.status = [];
            this.form.prioridades = [];

            const filter = this.getFilter();

            if (filter) {

                this.setLoading()

                this.repositories.gerenciamento.list(filter)
                    .then(({ data }) => {

                        this.form.subgrupos = this.clone(data.form.subgrupos);
                        this.form.status = this.clone(data.form.status);
                        this.form.prioridades = this.clone(data.form.prioridades);
                    })
                    .catch(this.handleError)
                    .finally(() => {
                        this.subgrupoChange();
                        this.unsetLoading();
                    });
            }

        },
        subgrupoChange() {

            this.model.statusId = [];
            this.model.prioridadesId = [];

            this.form.status = [];
            this.form.prioridades = [];

            const filter = this.getFilter();

            if (filter) {

                this.setLoading()

                this.repositories.gerenciamento.list(filter)
                    .then(({ data }) => {

                        this.form.status = this.clone(data.form.status);
                        this.form.prioridades = this.clone(data.form.prioridades);
                    })
                    .catch(this.handleError)
                    .finally(() => {
                        this.statusChange();
                        this.unsetLoading();
                    });
            }

        },
        statusChange() {

            this.model.prioridadesId = [];

            this.form.prioridades = [];

            const filter = this.getFilter();

            if (filter) {

                this.setLoading()

                this.repositories.gerenciamento.list(filter)
                    .then(({ data }) => {

                        this.form.prioridades = this.clone(data.form.prioridades);
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }

        },
        getFilter() {

            const filter = this.clone(this.model)
            return this.camelObjectKeysToSnakeRecursive(filter)

        },
        handleOpen(item) {

            const id = item.id;
            this.$router.push({name: 'manutencao-gerenciamento-edit', params: {id}})
        },
        resetFilters() {

            this.model.usuarioSolicitanteId = null;
            this.model.servicosId = null;
            this.model.unidadesSolicitantesId = null;
            this.model.infraestruturasSolicitantesId = null;
            this.model.gruposId = null;
            this.model.subgruposId = null;
            this.model.statusId = null;
            this.model.prioridadesId = null;

            this.form.servicos = [];
            this.form.unidadesSolicitantes = [];
            this.form.infraestruturasSolicitantes = [];
            this.form.grupos = [];
            this.form.subgrupos = [];
            this.form.status = [];
            this.form.prioridades = [];

            this.model.periodo.date.start = this.minDate;
            this.model.periodo.date.end = this.maxDate;

            this.$refs.Form.validate(this.$refs.DataTable.search);
        },
        rowClass(item) {

            if (item) {

                if (item.mensagensResposta.length > 0 && !item.mensagensResposta[0].resposta) {

                    return 'table-warning';
                }

                switch (item.statusId) {

                    case this.enums.statusTipo.EM_ATENDIMENTO: {

                        return 'table-success'
                    }
                    case this.enums.statusTipo.CANCELADO: {

                        return 'table-danger'
                    }
                    default: {

                        return ''
                    }
                }
            }
        },
        handleCancel(item) {

            this.$refs.modalCancelamento.open(item)
        },
        handleMessage(item) {

            this.$refs.modalMensagens.open(item)
        },
        handleFinalize(item) {

            this.showConfirmation(
                `Deseja finalizae a solicitação ${item.codigo}?`,
                async () => this.finalize(item),
                async () => null,
            )

        },
        finalize(item) {

            this.setLoading()

            const request = {
                acao: 'finalizar',
            }

            this.repositories.gerenciamento.update(
                item.id,
                request
            )
                .then(() => {
                    this.$refs.modal.hide()
                    this.$emit('refresh')
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        }
    },
    mixins: [error, formats, repository, stringCase, object, file],
    watch: {
        'model.periodo.date.start'(newVal) {
            if (newVal) {
                this.model.periodo.date.start = moment(newVal).format('YYYY-MM-DD');
            }
        },
        'model.periodo.date.end'(newVal) {
            if (newVal) {
                this.model.periodo.date.end = moment(newVal).format('YYYY-MM-DD');
            }
        }
    }
}
</script>
